import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { ADMIN_DASHBOARD_ERROR, GETTING_ADMIN_DASHBOARD_DATA, GET_ADMIN_DASHBOARD_DATA } from "../types"

export const fetchAdminDashboardData = () => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: GETTING_ADMIN_DASHBOARD_DATA,
            payload: true
        })

        const response = await axios.get(`${baseUrl}/dashboards/administrative`, { headers })
        
        dispatch({
            type: GET_ADMIN_DASHBOARD_DATA,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: ADMIN_DASHBOARD_ERROR,
            error
        })
    }
}
